import { hasDateStatus, type PackageCardData } from '@chewy/chat-library-common';
import styles from './OrderCardPackages.module.scss';
import OrderCardPackage from './OrderCardPackage';
import { first } from 'lodash';

interface OrderCardPackagesProps {
  data: PackageCardData[];
  isSelectable?: boolean;
}

export default function OrderCardPackages({ data, isSelectable = false }: OrderCardPackagesProps) {
  const packages = data;
  const totalPackages = packages.length;
  const firstItem = first(packages);
  const title = firstItem?.title || '';
  const stackDateStatus = packages.some((packageItem) => hasDateStatus(packageItem.dateStatus));

  return (
    <div className={styles.container}>
      <h3 className={styles.orderNumber}>{title}</h3>

      <div className={styles.packagesRow}>
        {packages.map((packageItem, index) => {
          return (
            <OrderCardPackage
              key={packageItem.orderId || index}
              data={[{ ...packageItem, packageNumber: `${index + 1}`, totalPackages }]}
              isSelectable={isSelectable}
              stackDateStatus={stackDateStatus}
            />
          )
        })}
      </div>
    </div>
  );
}
